import { useEffect, useState } from 'react';
import styles from '../styles/ContactPage.module.css';
import { fetchContactPage } from '../helpers/contentfulHelper';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const FORM_ENDPOINT = 'https://formspree.io/f/mnnewvzr';

const ContactPage = () => {
  const [status, setStatus] = useState('idle');
  const [copy, setCopy] = useState(null);

  useEffect(() => {
    const loadContactPage = async () => {
      const entry = await fetchContactPage();

      if (entry?.fields?.copy) {
        setCopy(entry.fields.copy);
      }
    };      

    loadContactPage();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('submitting');

    const formData = new FormData(e.target);

    try {
      const response = await fetch(FORM_ENDPOINT, {
        method: 'POST',
        body: formData,
        headers: { Accept: 'application/json' },
      });

      if (response.ok) {
        setStatus('success');
        e.target.reset();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    }
  };

  return (
    <section className={styles.page}>
      <div className={styles.container}>
        <header className={styles.header}>
          <p className={styles.kicker}>Contact</p>
          <h1 className={styles.title}>Contact Us</h1>
        </header>

        <div className={styles.grid}>
          <div className={styles.left}>
            {copy && (
              <div className={styles.intro}>
                {documentToReactComponents(copy)}
              </div>
            )}

            {status === 'success' ? (
              <p className={styles.success}>
                Thanks for your message — we’ll be in touch shortly.
              </p>
            ) : (
              <form onSubmit={handleSubmit} className={styles.form}>
                <input type="text" name="_gotcha" style={{ display: 'none' }} />

                <input
                  type="text"
                  name="name"
                  placeholder="Your name"
                  required
                />

                <input
                  type="email"
                  name="email"
                  placeholder="Your email"
                  required
                />

                <textarea
                  name="message"
                  placeholder="Your message"
                  rows="5"
                  required
                />

                <button type="submit" disabled={status === 'submitting'}>
                  {status === 'submitting' ? 'Sending…' : 'Send message'}
                </button>

                {status === 'error' && (
                  <p className={styles.error}>
                    Something went wrong. Please try again.
                  </p>
                )}
              </form>
            )}
          </div>

          <div className={styles.right}>
            <div className={styles.map}>
              <iframe
                title="J. Hodson & Son Ltd"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3668.6118195164854!2d-2.5029117000000003!3d53.4930148!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x487b07754b10518b%3A0x12203738a1204278!2sJ.%20Hodson%20%26%20Son%20Ltd!5e1!3m2!1sen!2suk!4v1765609380806!5m2!1sen!2suk"
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactPage;
